import FeaturedContentV3, {
  FeaturedContentV3Parameters,
} from "@components/layouts/content/FeaturedContentV3";

import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";
import { useLockedContents } from "../hooks/useLockedContent";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<FeaturedContentV3Parameters>(props, ref);

  const { image, buttonText, title, subTitle } = getParameterValues([
    "image",
    "buttonText",
    "title",
    "subTitle",
  ]);

  const { isLockedContent } = useLockedContents(content ? [content] : []);
  const lockedContents = isLockedContent.result;

  return (
    <FeaturedContentV3
      content={{ ...content, isLocked: lockedContents?.[0]?.isLocked }}
      parameterValues={{
        image,
        buttonText,
        title,
        subTitle,
      }}
      isLoading={isLoading}
      onItemPress={props.onItemPress}
    />
  );
});

export const FeaturedContentComponentV3: ContentComponent = {
  identifier: "COM:FEATUREDCONTENT:CARD:V3",
  component: Component,
};
